import React, { useCallback } from "react";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCalendar,
    faCopy,
    faEye,
    faTrash,
} from "@fortawesome/free-solid-svg-icons";
import CellInput, { CellTextarea } from "../../../global/CellInput";
import { generateStatusStyle, openBankingStatus, bankStatus as bankStatusObj } from "../../OpenBankingUtils";
import { useAppContext } from "../../../../AppContext";
import { useTranslation } from "react-i18next";
import { useDuplicatePayroll, useGetPayrollById, useSavePayroll } from "../service";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { bankStatusStyle } from "../../OpenBankingUtils";


const moment = require("moment");

export const useGeneratePayRollColumns = ({
    handleParamsChange,
    getFilteredResults,
    filters,
    tableRows,
    refreshStatistics,
} = {}) => {

  const history = useHistory();
  const [deleteLoading, setDeleteLoading] = React.useState(false);

  const { duplicatePayroll, loading:duplicateLoading } = useDuplicatePayroll({onSuccess:(payroll)=>{
            refreshStatistics();
            history.push("/edit-payroll/" + payroll.id);
    }
  });

  const {getPayroll} =useGetPayrollById()
  const {savePayrollFn}=useSavePayroll()

    const { t } = useTranslation("translations");

    const {
    company: [fullCompany],
    user: [user],
    } = useAppContext();
    const userCanDuplicate = user.role.id !== 7;


    const profileIdOptions = fullCompany?.branches?.map((branch) => ({
        value: branch.id,
        label: `${branch.businUnitCode} | ${branch.sellerName}`,
    })) || [];


    const currencyOptions = [
        { value: "ALL", label: "Lek" },
        { value: "EUR", label: "Euro" },
        { value: "USD", label: "USD" },
    ];

    const profiscStatus = [
        {
            label: t(openBankingStatus.DRAFT.label),
            value: openBankingStatus.DRAFT.value
        },
        {
            label: t(openBankingStatus.READY_FOR_APPROVAL.label),
            value: openBankingStatus.READY_FOR_APPROVAL.value
        },
        {
            label: t(openBankingStatus.SENT_TO_BANK.label),
            value: openBankingStatus.SENT_TO_BANK.value
        },
        {
            label: t(openBankingStatus.PENDING.label),
            value: openBankingStatus.PENDING.value
        },
        {
            label: t(openBankingStatus.DELETED.label),
            value: openBankingStatus.DELETED.value
        },
    ]
    const bankStatus = [
        {
            label: t(bankStatusObj.RECEIVED.label),
            value: bankStatusObj.RECEIVED.value
        },
        {
            label: t(bankStatusObj.WAITING.label),
            value: bankStatusObj.WAITING.value
        },
        {
            label: t(bankStatusObj.PAID.label),
            value: bankStatusObj.PAID.value
        },
        {
            label: t(bankStatusObj.REJECTED.label),
            value: bankStatusObj.REJECTED.value
        },
        {
            label: t(bankStatusObj.PARTIALLY_PROCESSED.label),
            value: bankStatusObj.PARTIALLY_PROCESSED.value
        },
        {
            label: t(bankStatusObj.CANCELLED.label),
            value: bankStatusObj.CANCELLED.value
        },
    ]

    const periodFilter = (filterOptions) => {
        let selected = filters?.params?.["period"]
        return (
            <div>
                <DatePicker
                    id="periodDate"
                    placeholderText={t("queue.selectDate")}
                    dateFormat="MM/yyyy"
                    showMonthYearPicker
                    showFullMonthYearPicker
                    portalId="root"
                    popperPlacement="bottom-end"
                    popperProps={{
                        strategy: "fixed"
                    }}
                    onChange={(date) => {
                        let value = new Date(date).setHours(2, 0, 0, 0)
                        filterOptions.filterCallback(value)
                        value = moment(value).format("MM/yyyy")
                        handleParamsChange(null, "period", value)
                        getFilteredResults({ data: { ...filters, params: { ...filters.params, "period": value } } })
                    }
                    }
                    customInput={
                        <div className="form-control d-flex justify-content-center align-items-center" style={{ width: 150, position: "relative" }}>
                            <FontAwesomeIcon icon={faCalendar} />
                            <div className="ml-1">
                                {filters?.params?.["period"] ? filters?.params?.["period"] : t("vat.none")}
                            </div>
                            {selected && <div
                                onClick={(e) => {
                                    e.stopPropagation()
                                    filterOptions.filterCallback("")
                                    handleParamsChange(null, "period", null)
                                    getFilteredResults({ data: { ...filters, params: { ...filters.params, "period": null } } })
                                }}
                                style={{ position: "absolute", zIndex: 99999, top: 6, right: 10, padding: "0px 5px", cursor: "pointer", fontSize: 16, fontWeight: 400 }}>
                                {`\u2715`}
                            </div>}
                        </div>
                    }
                />
            </div>
        )
    }

    const deletePayroll = async(payrollId)=>{
        setDeleteLoading(true);
        const  payroll=await getPayroll(payrollId)
        savePayrollFn({
            payroll,
            onSuccess: () => {
                setDeleteLoading(false);
                getFilteredResults({ pageSize:tableRows.rowsPerPage, page:tableRows.currentPage   })
                refreshStatistics();
            },
            actionStatus: { action: "DELETE"}
        })
    }


    const getStatus = useCallback((payroll)=>generateStatusStyle(payroll?.workflowStatus?.id, t),[t]);
    const getBankStatus = useCallback((payroll)=>bankStatusStyle(payroll?.bankStatus?.mappedStatusType?.id, t),[t]);

    return [

        {
            header: "ID",
            field: 'requestId',
            style: { minWidth: "200px", maxWidth: "200px" },
            body: (payroll) => <CellInput value={payroll?.requestId ?? ""} width={180} onFocus={(event) => event.target.select()} />,
            filter: true,
            default: true,
            persisted: true,
            mobile: { priority: 1, isTitle: true, group: "identity" },
        },
        {
            header: t(["payRoll.registerDate"]),
            field: "recordDate",
            body: (payroll) => payroll?.recordDate ? moment(payroll?.recordDate).format("DD/MM/YYYY HH:mm") : "",
            style: { minWidth: 180, maxWidth: 180 },
            filter: true,
            filterType: "DATE",
            filterConfig: {
                like: false,

            },
            sortable: true,
            default: true,
            persisted: true,
            formattedExportValue: true,
            preventExcelFormat: true,
            mobile: { priority: 1, group: "dates" },

        },
        {
            header: t("queue.period"),
            style: { minWidth: "170px", maxWidth: "170px" },
            field: 'period',
            body: payroll => payroll.period || "",
            filter: true,
            sortable: true,
            default: true,
            persisted: true,
            filterElement: periodFilter,
            mobile: { priority: 1, group: "dates" },
        },
        {
            header: t(["payRoll.profiscStatus"]),
            field: "workflowStatusObj",
            style: { minWidth: "150px", maxWidth: "300px" },
            filter: false,
            default: true,
            persisted: true,
            mobile: { priority: 1, isBadge: true, group: "status" },
            format:(payroll)=>getStatus(payroll).status,
            body: (payroll) => {
                const status = getStatus(payroll)

                return (
                    <h4 className="mb-0">
                        <small className={`badge badge-${status.badgeClass} ml-2`}>
                            {status?.status}
                        </small>
                    </h4>
                );
            },
            filterType: "MULTISELECT",
            filterConfig: {
                options: profiscStatus,
            }
        },

        {
            header: t(["payRoll.bankStatus"]),
            field: "bankStatusDisplayName",
            style: { minWidth: "150px", maxWidth: "150px" },
            filter: false,
            default: true,
            persisted: true,
            mobile: { priority: 1, isBadge: true, group: "status" },
            format:(payroll)=>getBankStatus(payroll).status,
            body: (payroll) => {
                const bankStatus =getBankStatus(payroll,t)

                return (
                    <h4 className="mb-0">
                        <small className={`badge badge-${bankStatus.badgeClass} ml-2`}>
                            {bankStatus?.status}
                        </small>
                    </h4>
                );
            },
            filterType: "DROPDOWN",
            filterConfig: {
                options: bankStatus,
                optionValue: "value",
                optionLabel: "label",
            },
        },
        {
            header: t(["payRoll.originalBankStatus"]),
            field: "bankStatus.originalBankStatus",
            style: { minWidth: "200px", maxWidth: "200px" },
            filter: false,
            default: true,
            persisted: true,
            mobile: { priority: 3 },
        },
        // {
        //     header: t(["payRoll.transactionNo"]),
        //     field: "transactionId",
        //     style: { minWidth: "150px", maxWidth: "150px" },
        //     filter: true,
        //     default: true,
        //     persisted: true,
        // },
        // {
        //     header: t(["payRoll.transactionDate"]),
        //     field: "transactionDate",
        //     body: (payroll) => payroll?.transactionDate ? moment(payroll?.transactionDate).format("DD/MM/YYYY HH:mm") : "",
        //     style: { minWidth: 200, maxWidth: 200 },
        //     filter: true,
        //     filterType: "DATE",
        //     filterConfig: {
        //         like: false,

        //     },
        //     default: true,
        //     persisted: true,
        //     sortable: true,
        //     formattedExportValue: true,
        //     preventExcelFormat: true,

        // },
        {
            header: t(["home.actions"]),
            style: { minWidth: "240px", maxWidth: "240px" },
            field: "actions",
            mobile: { priority: "action", group: "actions" },
            body: invoice => (
                <div className='d-flex align-items-center'>
                    <Link
                        to={"/edit-payroll/"+invoice.id}
                        style={{ color: "#0275d8" }}
                        className={"nav-link text-primary p-0 d-flex align-items-center mr-2"}>
                        <FontAwesomeIcon icon={faEye} className="mx-1" />
                        {t('common.view')}
                    </Link>
                    {invoice?.status?.status != 'ERROR' && userCanDuplicate && <a
                        href="#"
                        className={`${duplicateLoading || deleteLoading ? "disabled" : ""} nav-link p-0 d-flex align-items-center ml-2`}
                        onClick={() => {
                            if (!duplicateLoading && !deleteLoading) {
                                duplicatePayroll(invoice?.id?.toString());
                            }
                        }}>
                        <FontAwesomeIcon className="mr-1" icon={faCopy} />
                        {t("invoice.duplicate")}
                    </a>
                        }

                    {invoice?.workflowStatus?.name === "DRAFT"  &&  <a
                        href="#"
                        className={`${deleteLoading || duplicateLoading ? "disabled" : ""} nav-link p-0 d-flex align-items-center text-danger ml-1`}
                        onClick={() => {
                            if (!deleteLoading && !duplicateLoading) {
                                deletePayroll(invoice.id?.toString());
                            }
                        }}>
                        <FontAwesomeIcon icon={faTrash} className="mr-1" />
                        {t('common.delete')}

                    </a>
                    }
                </div>
            ),
            default: true,
            persisted: true
        },
        {
            header: t(["invoice.currency"]),
            field: "accountCurrency",
            filter: false,
            default: true,
            persisted: true,
            style: { minWidth: "150px", maxWidth: "150px" },
            body: (payroll) => payroll?.accountCurrency,
            filterType: "MULTISELECT",
            filterConfig: {
                options: currencyOptions
            },
            mobile: { priority: 2 },
        },
        {
            header: t(['home.amount']),
            field: "amount",
            style: { minWidth: "150px", maxWidth: "250px" },
            default: true,
            persisted: true,
            mobile: { priority: 1, group: "financial" },
        },
        {
            header: t("payRoll.executionDate"),
            field: "requestedExecutionDate",
            body: (payroll) => payroll?.requestedExecutionDate ? moment(payroll?.requestedExecutionDate).format("DD/MM/YYYY HH:mm") : "",
            style: { minWidth: 230, maxWidth: 230 },
            filter: true,
            filterType: "DATE",
            filterConfig: {
                like: false,
            },
            persisted: true,
            formattedExportValue: true,
            preventExcelFormat: true,
            sortable: true,
            mobile: { priority: 2 },
        },
        {
            header: t(["item.description"]),
            field: "description",
            style: { minWidth: "180px", maxWidth: "180px" },
            body: transaction => <CellTextarea width={165} value={transaction.description ?? ""} onFocus={(event) => event.target.select()} />,
            mobile: { priority: 2 },
        },
        {
            header: t(["company.bankAccount"]),
            field: "companyAccountNumber",
            body: (payroll) => <CellInput value={payroll?.companyAccountNumber ?? ""} width={180} onFocus={(event) => event.target.select()} />,
            filter: true,
            default: true,
            persisted: true,
            mobile: { priority: 2 },
        },
        {
            header: t(["payRoll.debitAccountBank"]),
            field: "companyBankAccount.financialInstitution.name",
            format:(payroll)=>payroll?.companyBankAccount?.financialInstitution?.name ?? "",
            style: { minWidth: "200px", maxWidth: "200px" },
            filter: true,
            persisted: true,
            default: true,
            mobile: { priority: 1, group: "identity" },
        },
        {
            header: t(["payRoll.paymentAprovUser"]),
            field: "approvalUser",
            style: { minWidth: "150px", maxWidth: "200px" },
            filter: true,
            mobile: { priority: 3 },
        },
        {
            header: "IBAN",
            field: "ibanDebit",
            body: (payroll) => <CellInput value={payroll?.ibanDebit ?? ""} width={180} onFocus={(event) => event.target.select()} />,
            filter: true,
            default: true,
            persisted: true,
            mobile: { priority: 3 },
        },
        {
            header: t("payRoll.accountName") ,
            field: "accountName",
            style: { minWidth: "150px", maxWidth: "150px" },
            filter: true,
            default: true,
            persisted: true,
            mobile: { priority: 2 },
        },
        {
            header: t(["table.recordUser"]),
            field: "recordUser",
            style: { minWidth: "150px", maxWidth: "150px" },
            filter: true,
            mobile: { priority: 3 },
        },


    ];
};

